import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Health from './health';
import DentalAppointmentsForm from './dentalAppointmentsForm';
import PsychologistAppointmentsForm from './psychologistAppointmentsForm';
import NutritionistAppointmentsForm from './nutritionistAppointmentsForm';
import NutriInfoForm from './nutriInfo';
import PsychoInfoForm from './psychoInfo';
import DentalInfoBeneficioForm from './dentalInfoBeneficio';
import AppointmentSchedule from './schedule/appointmentSchedule';

export default (
  <Route path="/homepage/saude">
    <Switch>
      <Route exact path="/homepage/saude" component={Health} />

      <Route
        path="/homepage/saude/agendamento-odontologia"
        component={DentalAppointmentsForm}
      />
      <Route
        path="/homepage/saude/agendamento-psicologia"
        component={PsychologistAppointmentsForm}
      />
      <Route
        path="/homepage/saude/agendamento-nutricionista"
        component={NutritionistAppointmentsForm}
      />
      <Route
        path="/homepage/saude/agendamento-nutricionista-info"
        component={NutriInfoForm}
      />
      <Route
        path="/homepage/saude/agendamento-psicologia-info"
        component={PsychoInfoForm}
      />
      <Route
        path="/homepage/saude/agendamento-odontologia-info"
        component={DentalInfoBeneficioForm}
      />
      <Route
        path="/homepage/saude/clinica/:especialidade"
        component={AppointmentSchedule}
      />
    </Switch>
  </Route>
);
